module.exports = __webpack_public_path__ + "img/USDT_high.3455c9d8.jpg";